<template>
  <div class="cart--block">
    <cart-review-list>
      <cart-review-list-item
        v-for="(item, index) in cartItems"
        :key="index"
        :item="item"
      />
    </cart-review-list>
    <div class="total--block pt15-md pb20-md py10">
      <div class="bb-darkgray mb20-md mb10">
        <div class="sub-total d-flex align-items-center justify-content-between pb15-md pb10">
          <label for="" class="mb0">Subtotal</label>
          <p class="ff-nunito-bold mb0 pr30-md">
            {{ subtotalPrice | moneyToCurrencyFormat }}
          </p>
        </div>
        <div
          v-if="shippingFee"
          class="shipping d-flex justify-content-between pb15-md pb10"
        >
          <label for="" class="mb0">Shipping</label>
          <p class="ff-nunito-bold mb0 pr30-md">
            {{ shippingFee | moneyToCurrencyFormat }}
          </p>
        </div>
        <div
          v-if="discount && discount.amount > 0"
          class="shipping d-flex justify-content-between pb15"
        >
          <label for="" class="mb0">Discount</label>
          <p class="ff-nunito-bold mb0 pr30-md">
            {{ discount | moneyToCurrencyFormat }}
          </p>
        </div>
      </div>

      <div class="total d-flex align-items-center justify-content-between">
        <div class="d-flex flex-column">
          <label class="ff-nunito-bold mb10-md mb0">Total</label>
        </div>

        <p class="ff-nunito-bold mb0 pr30-md">
          {{ totalPrice | moneyToCurrencyFormat }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import CartReviewList from "./CartReviewList";
import CartReviewListItem from "./CartReviewListItem";

export default {
  components: {
    CartReviewList,
    CartReviewListItem
  },
  computed: {
    cartItems() {
      return this.$store.state.cart.items;
    },
    subtotalPrice() {
      return this.$store.state.cart.totalPrice;
    },
    shippingFee() {
      return this.$store.state.checkout.shipping.fee;
    },
    discount() {
      return this.$store.state.checkout.discount;
    },
    totalPrice() {
      const subtotalPrice = parseInt(this.subtotalPrice.amount);
      const shippingFee = (this.shippingFee ? parseInt(this.shippingFee.amount) : 0);
      const discount = (this.discount ? parseInt(this.discount.amount) : 0);

      return {
        amount: subtotalPrice + shippingFee - discount,
        currency: this.subtotalPrice.currency
      };
    }
  }
};
</script>
